import { StickyDefault as StickyDefaultSchema } from "@msidata/service-pro-api-schema";
import _ from "lodash";
import LZString from "lz-string";
import { getLocalStorage, setLocalStorage } from "../../../framework/core/core";
import { user } from "../../../framework/core/user";
import { ajax } from "../ajax";

export function loadGridStickyDefaults() {
    if (!localStorage.GridDefaultsRetrieved) {
        ajax({
            url: "User/GetGridDefaults",
            type: "GET"
        }).done(function (data) {
            localStorage.setItem("GridDefaultsRetrieved", "true");
            _.each(data.d.results, (value) => {
                if (!localStorage.getItem(value.EntityName)) {
                    value.Value = JSON.parse(value.Value);

                    value.Value.Columns = _.uniqBy(value.Value.Columns, "field");

                    setLocalStorage(value.EntityName, JSON.stringify(value));
                }
            });
        });

        $.each(user.companyData.Default, function (index, item) {
            if (!localStorage.getItem(item.EntityName)) {
                setLocalStorage(item.EntityName, item.Value);
            }
        });
    }
}

export function deleteGridStickyDefaults(args) {
    var field = args.Field || "Default",
        entityName = "StickyGrid_" + args.EntityName + "_" + field;

    localStorage.removeItem(entityName);

    ajax({
        url: "StickyDefault/DeleteGridDefault",
        type: "DELETE",
        data: { EntityName: entityName, Field: field }
    });
}

type GridColumn = kendo.ui.GridColumn & { zHeaderElement?: any; }

interface StickyDefaultValue {
    Columns: GridColumn[];
    PageSize?: number;
    Sort?: any[];
    Filter?: string;
}

type StickyDefault = Partial<Omit<StickyDefaultSchema, "Value"> & { Value: StickyDefaultValue }>

function mergeStickyDefaultValues(newValue: StickyDefaultValue, existingValue?: StickyDefaultValue) {
    if (!existingValue) {
        return newValue;
    }
    const previouslyHiddenColumns = existingValue.Columns
        .filter(c => c.hidden)
        .filter(c => !newValue.Columns.find(col => col.field === c.field));
    const mergedValue = { ...existingValue, ...newValue };
    const union = _.uniqBy([...mergedValue.Columns, ...previouslyHiddenColumns], JSON.stringify);
    mergedValue.Columns = union;
    return mergedValue;
}

function cleanUpStickyDefault(stickyDefault: StickyDefault) {
    $.each(stickyDefault.Value.Columns, function (index, column) {
        if (column.zHeaderElement) {
            column.zHeaderElement = null;
        }
    });
    return stickyDefault;
}

function cacheStickyDefault(stickyDefault: StickyDefault) {
    var stringified = JSON.stringify(
        stickyDefault,
        (key, val) => key === "prevObject" ? undefined : val
    );
    var compressed: string = LZString.compressToUTF16(stringified);

    localStorage.setItem(stickyDefault.EntityName, compressed);
}

function patchGridDefault(value: Partial<StickyDefaultSchema>) {
    ajax({
        url: "StickyDefault/UpdateGridDefaults",
        type: "PATCH",
        data: value
    });
}

export function setGridStickyDefaults(args: StickyDefault) {
    const field = args.Field ?? "Default",
        entityName = `StickyGrid_${args.EntityName}_${field}`;
    let newValue: StickyDefaultValue = { ...args.Value };

    const nestedGrid = args.Field?.contains("nestedGrid");
    const isAdminConsole = localStorage.defaultCompanyGuid;
    if (nestedGrid || isAdminConsole) {
        return;
    }

    let existingStickyDefault: StickyDefault = null;
    const localStorageString = localStorage.getItem(entityName);
    if (localStorageString) {
        existingStickyDefault = JSON.parse(LZString.decompressFromUTF16(localStorageString));
    }

    let newStickyDefault: StickyDefault = {
        EntityName: entityName,
        Field: field,
        Value: mergeStickyDefaultValues(newValue, existingStickyDefault?.Value)
    }

    cacheStickyDefault(newStickyDefault);

    // clean up object before stringify
    const cleanedUpStickyDefault = cleanUpStickyDefault(newStickyDefault);

    const stickyDefaultData: Partial<StickyDefaultSchema> = {
        ...cleanedUpStickyDefault,
        Value: JSON.stringify(cleanedUpStickyDefault.Value)
    };

    patchGridDefault(stickyDefaultData);
}

export function getGridStickyDefaults(args: { EntityName: string, Field?: string }): any {
    var entityName = args.EntityName,
        field = args.Field || "Default";
    var key = "StickyGrid_" + entityName + "_" + field;

    var value = localStorage.getItem(key);
    if (value) {
        value = $.parseJSON(LZString.decompressFromUTF16(value));
        return value;
    } else {
        return {};
    }
}

export function getBooleanStickyValue(sticky) {
    var boolDefault,
        savedDefault = getLocalStorage(sticky);

    if (savedDefault == "true" || savedDefault == "True") {
        boolDefault = true;
    } else if (savedDefault == "false" || savedDefault == "False") {
        boolDefault = false;
    }

    return boolDefault;
}